import React from "react";
import { useEffect } from "react";
import HomeHeaderComponent from '../common/header/homeheader/HomeHeaderComponent';
import HomeFooterComponent from '../common/footer/homefooter/HomeFooterView';
import "./sticky.css";


function HomeLayout(props) {

    useEffect(() => {
      const header = document.getElementById("myHeader");
      const sticky = header.offsetTop;
      const scrollCallBack = window.addEventListener("scroll", () => {
        if (window.pageYOffset > sticky) {
          header.classList.add("home__sticky");
        
        } else {
          header.classList.remove("home__sticky");
      
        }
      });
      return () => {
        window.removeEventListener("scroll", scrollCallBack);
      };
    }, []);
  
    return (
      <div>
      
        <header id="myHeader" className="home__header">
        <HomeHeaderComponent />
        </header>
        {props.children}
        <HomeFooterComponent />
   
      </div>
    );
  }
  
  export default HomeLayout;
  